import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login.component';
import { AuthGuard } from '../app.guard';

const routes: Routes = [
  {
    path: 'login', component: LoginComponent, canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/login/login-routing.module.ts